import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/cashAccount/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/cashAccount'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/cashDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/cashDetail'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/cashRecord/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/cashRecord'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/incomeDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/incomeDetail'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/bankCard/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/bankCard'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/accountRecharge/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/accountRecharge'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/helpBuyAccount/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/helpBuyAccount'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/rechargePay/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/rechargePay'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/cashOut/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/cashOut'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/newCashOut/index'), // copy的cashOut，由于帮买也会用到cashOut这个页面，但是帮买不需要支付宝
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/newCashOut'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/cashOutResult/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/wallet/cashOutResult'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/unbindAlipay/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/wallet/unbindAlipay',
    meta: {
      title: '解绑支付宝'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/transfer/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/wallet/transfer',
    meta: {
      title: '等待中'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/accountLogoff/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/wallet/accountLogoff',
    meta: {
      title: '账号注销'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/bankCardList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/wallet/bankCardList',
    meta: {
      title: '银行卡'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/wallet/serviceFeeDetails/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/wallet/serviceFeeDetails',
    meta: {
      title: '闪送'
    }
  }
]
